module.exports = __webpack_public_path__ + "static/media/atomizador_rotativo_disco_2.e535ef7f.png";